"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("./Text"));
var _colors = _interopRequireDefault(require("../theme/colors"));
var Services = _interopRequireWildcard(require("../services"));
var _system = require("@mui/system");
var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @param {*} param0 
 */
var Title = function Title(_ref) {
  var title = _ref.title,
    breadcrumbs = _ref.breadcrumbs,
    subheader = _ref.subheader,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle;
  var theme = (0, _system.useTheme)();
  var styles = {
    breadCrumbContent: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 20
    },
    breadCrumbIcon: {
      marginRight: 2,
      fontSize: 20
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({}, customStyle)
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    veryBold: true,
    color: _colors["default"].mainTextGrey,
    margin: breadcrumbs ? "10px 0 5px 0" : "10px 0 20px 0"
  }, title), breadcrumbs && /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.breadCrumbContent
  }, breadcrumbs.map(function (breadcrumb) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: Services.concatTokens(breadcrumb.title)
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      onClick: breadcrumb.onClick || null,
      align: "center",
      medium: true,
      margin: "0px 5px 0px 0px",
      display: "inline-block",
      customStyle: {
        letterSpacing: '0.6px',
        cursor: 'pointer'
      },
      link: breadcrumb.link || null
    }, breadcrumb.title), /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], {
      style: styles.breadCrumbIcon
    }));
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    isSelected: true,
    color: theme.palette.primary.main,
    display: "inline-block",
    customStyle: {
      letterSpacing: '0.6px'
    }
  }, subheader)));
};
var _default = exports["default"] = Title;